import ApiBase from '@/api/api-base'
import {ACTIVE_BASE_REST, PUBLIC} from '@/api/constants'

const baseUrl = '/message/notification'

export class MessageNotification extends ApiBase {
    constructor (store) {
        const path = `${ACTIVE_BASE_REST}${baseUrl}`
        super(store, path)
    }

    send(id, showProgress) {
        return this._request({
            action: `${this._urlencode(id)}/send`,
            method: 'PATCH',
            showProgress
        })
    }

    sendDemo(id, showProgress) {
        return this._request({
            action: `${this._urlencode(id)}/demo`,
            method: 'PATCH',
            showProgress
        })
    }

}

export class PublicMessageNotification extends ApiBase {
    constructor (store) {
        const path = `${PUBLIC}${baseUrl}`
        super(store, path)
    }

    subscribe(model) {
        return this._request({
            action: 'subscribe',
            method: 'POST',
            body: model
        })
    }
}